import { useMemo, useState } from 'react'
import Swal from 'sweetalert2'
import TypyPlacowekService from '@/services/TypyPlacowekService'

export default function useTypyPlacowekModal(loadData) {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [editingItem, setEditingItem] = useState(null)
	const [formType, setFormType] = useState('')
	const [isSaving, setIsSaving] = useState(false)

	const openCreateModal = () => {
		setEditingItem(null)
		setFormType('')
		setIsModalOpen(true)
	}

	const openEditModal = item => {
		setEditingItem(item)
		setFormType(item?.typ || '')
		setIsModalOpen(true)
	}

	const closeModal = () => {
		setIsModalOpen(false)
		setEditingItem(null)
		setFormType('')
		setIsSaving(false)
	}

	const handleSubmit = async e => {
		e.preventDefault()
		const type = formType.trim()
		if (!type) return

		setIsSaving(true)
		const result = editingItem?._id
			? await TypyPlacowekService.update(editingItem._id, { typ: type })
			: await TypyPlacowekService.create({ typ: type })

		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie zapisac typu placowki',
				icon: 'error',
			})
			setIsSaving(false)
			return
		}

		closeModal()
		await loadData()
	}

	const handleDelete = async item => {
		const confirm = await Swal.fire({
			title: 'Czy na pewno?',
			text: `Usunac typ placowki "${item?.typ || '-'}"?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Tak, usun',
			cancelButtonText: 'Anuluj',
		})
		if (!confirm.isConfirmed) return

		const result = await TypyPlacowekService.delete(item?._id)
		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie usunac typu placowki',
				icon: 'error',
			})
			return
		}

		await loadData()
		Swal.fire({
			title: 'Usunieto',
			text: 'Typ placowki zostal usuniety',
			icon: 'success',
		})
	}

	const buttons = useMemo(
		() => [
			{
				type: 'add',
				label: 'Dodaj nowe',
				onClick: openCreateModal,
			},
		],
		[]
	)

	return {
		isModalOpen,
		editingItem,
		formType,
		setFormType,
		isSaving,
		openEditModal,
		handleDelete,
		closeModal,
		handleSubmit,
		buttons,
	}
}
